var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thirdTest"},[_c('div',[_vm._v("授权成功:"+_vm._s(_vm.oData))])])
}
var staticRenderFns = []

export { render, staticRenderFns }